import { useQuery } from 'react-query'

import { QUERY_KEYS } from '../../api'
import BlocktrainApi from './api'

const useBlocktrainStatusCount = () => {
  const { data: blocktrainStatusCount, isLoading: blocktrainStatusCountIsLoading } = useQuery(
    [QUERY_KEYS.BLOCKTRAIN_STATUS_COUNT],
    () => BlocktrainApi.getStatusCounts(),
    {
      staleTime: Infinity,
    },
  )

  return {
    blocktrainStatusCount,
    blocktrainStatusCountIsLoading,
  }
}

export default useBlocktrainStatusCount
